class TextLinksStrip {
	constructor( el ) {

		let listItems = el.querySelectorAll(".block-text-and-links-list__list-item ");

		listItems.forEach((item) => {

			let tl = gsap.timeline({
				scrollTrigger: {
					trigger: item,
					toggleActions: "restart none none reset"
				}
			});

			tl.set(item, { autoAlpha: 1 });
			tl.from(item, 0.5, {
				y: 100,
				delay: -1.5,
				ease: Power2.out
			});
		});

	}
}

export default TextLinksStrip;
